<template>
  <el-tooltip class="item" effect="dark" :content="tipContent" placement="bottom" :disabled="disabled">
    <div style="">
      <el-button :size="size" :type="type" :plain="plain" :disabled="!disabled" @click="$emit('click')" :loading="loading">{{ text }}</el-button>
    </div>
  </el-tooltip>
</template>
<script>
import * as XLSX from 'xlsx';

export default {
  name: 'tooltipButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tipContent: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      required: true,
    },
    header: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    download(arr, widthList = []) {
      const data = [];
      for (let i = 0; i <= arr.length; i += 1048570) {
        data.push(arr.slice(i, i += 1048570));
      }
      const sheetList = [];
      data.forEach((item, index) => {
        sheetList[index] = XLSX.utils.json_to_sheet([this.header, ...item], { skipHeader: true });
        if (!sheetList[index]['!cols']) {
          sheetList[index]['!cols'] = [];
        }
        if (widthList.length) {
          widthList.forEach((width, colIndex) => {
            if (!sheetList[index]['!cols'][colIndex]) {
              sheetList[index]['!cols'][colIndex] = {};
            }
            sheetList[index]['!cols'][colIndex].wch = width;
          });
        }
      });
      const wb = XLSX.utils.book_new();
      sheetList.forEach((item, index) => {
        XLSX.utils.book_append_sheet(wb, item, `Sheet${index + 1}`);
        XLSX.writeFile(wb, this.fileName);
      });
    },
  },
};
</script>
<style scoped>
.item {
  display: inline-block;
  /* float: right; */
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/base/downloadJsonToExcel.vue